import { useState, useEffect } from 'react';

export const useWishlist = (callback = null) => {
  const [state, setState] = useState(window.Shopify.wishlist);

  useEffect(() => {
    const handleWishListUpdate = () => {
      setState(window.Shopify.wishlist);
      if (callback) {
        callback(window.Shopify.wishlist?.wishListCollections);
      }
    };
    window.addEventListener('wishlistUpdated', handleWishListUpdate);

    return () => {
      window.removeEventListener('wishlistUpdated', handleWishListUpdate);
    };
  }, [callback]);

  return { ...state };
};
